import {ConstantsParser} from "../../../ConstantsParser";

export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      hasTitle: false,
      text: 'Example Title',
      progressWidth: 30,
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    return `<div class="${classes}">Primary</div>`;
  }

  classes() {
    return []
  }

  styles() {
    return [
      {property: 'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f56564, #f56564)'},
    ]
  }

  containerClasses() {
    return [
      {property: 'BorderStyle', value: 'BORDER_NONE'},
      {property: 'Rounded', value: 'ROUNDED_FULL'},
    ]
  }

  containerStylesProperties() {
    return [
      {property: 'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #cccccc, #cccccc)'},
      {property: 'HeightStyle', styleProperty: 'height', value: '30px'},
    ]
  }

  textClasses() {
    return [
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'Rounded', value: 'ROUNDED_FULL'},
      {property: 'FontWeight', value: 'NORMAL'},
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
      {property: 'TextTransform', value: 'UPPERCASE'}
    ]
  }

  textStylesProperties() {
    return [
      {property: 'TextColor', styleProperty: 'color', value: 'rgba(64,62,62, 1)'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses(),
      },
      containerStyles: {
        desktop: this.containerStylesProperties(),
        tablet: this.containerStylesProperties(),
        phone: this.containerStylesProperties(),
      },
      textClasses: {
        desktop: this.textClasses(),
        tablet: this.textClasses(),
        phone: this.textClasses(),
      },
      textStyles: {
        desktop: this.textStylesProperties(),
        tablet: this.textStylesProperties(),
        phone: this.textStylesProperties(),
      }
    }
  }
}
